<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="'社員'" />
		<CommonFlame :title="'社員一覧'">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn color="primary" dark @click="$router.push({ name: 'erp_user_new' })"
					><v-icon>mdi-plus</v-icon>社員追加</v-btn
				>
			</template>

			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters class="ma-2 d-flex" justify="end">
					<v-btn color="secondary" class="mb-2" @click="$router.push({ name: 'erp_user_new' })"
						><v-icon>mdi-plus</v-icon>社員追加</v-btn
					>
				</v-row>
			</template>

			<div class="table-container px-2 mt-4">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="users"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr class="no-click">
							<td>{{ item.user_info.employee_number }}</td>
							<td>
								{{ item.full_name }}
							</td>
							<td>{{ item.position }}</td>
							<td>
								<span v-for="(department, i) in item.departments" :key="`department-${i}`"
									>{{ department.name }}/</span
								>
							</td>
							<td>
								<template v-if="edit_flg">
									<v-row no-gutters justify="center">
										<v-btn @click="redirectToUserEdit(item.id)" color="secondary" small>
											<v-icon class="mr-2" small>mdi-pencil</v-icon>
											編集
										</v-btn>
									</v-row>
								</template>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import PaginationModule from "../../modules/PaginationModule.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		PaginationModule,
		FunctionTitle,
		CommonFlame,
	},
	data() {
		return {
			users: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			headers: [
				{ text: "社員番号", width: "200px" },
				{ text: "社員名", width: "200px" },
				{ text: "役職", width: "200px" },
				{ text: "所属部門", width: "200px" },
				{ text: "", width: "100px" },
			],
			edit_flg: false,
		}
	},
	created() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.fetchUsers(page)
	},
	computed: {
		hasAuthority() {
			return true
		},
	},
	methods: {
		fetchUsers(page) {
			const headers = authenticate.setHeader()

			axios
				.get("/erp/v1/users", {
					params: {
						page: page,
					},
					headers,
				})
				.then((res) => {
					this.edit_flg = res.data.edit_flg
					this.users = res.data.users
					console.log(this.users)
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchUsers(page)
		},
		redirectToUserEdit(userId) {
			this.$router.push({ name: "authorized_user_edit", params: { id: userId } })
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../stylesheet/user/user_index.scss";
</style>
